import { render, staticRenderFns } from "./stopLocation.vue?vue&type=template&id=50f54c48"
import script from "./stopLocation.vue?vue&type=script&lang=js"
export * from "./stopLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports